import { getImageUrl } from "helpers";


const PaymentItem = ({ data }) => {
    const { description, payments_method } = data;
    return (
        <div className="payment-item">
            <div className="payment-item__image">
                <div className="payment-item__image-container">
                    {
                        payments_method.map((item, index) => {
                            const imgSrc = getImageUrl(item.icon);
                            return (
                                <img key={index} src={imgSrc} alt="" />
                            );
                        })
                    }
                </div>
            </div>
            <div className="body2">{description}</div>
        </div>
    );
}

export default PaymentItem;